// ============================================
// PATHS DAS ROTAS
// ============================================

export const PATHS = {
  // Publicas
  LANDING: '/',
  LOGIN: '/login',
  REGISTER: '/registrar',

  // Privadas (App)
  APP_HOME: '/app',
  DASHBOARD: '/app/dashboard',

  // Produtos
  PRODUTOS: '/app/produtos',
  PRODUTO_NOVO: '/app/produtos/novo',
  PRODUTO_EDITAR: '/app/produtos/:id/editar',

  // Categorias
  CATEGORIAS: '/app/categorias',

  // Clientes
  CLIENTES: '/app/clientes',
  CLIENTE_NOVO: '/app/clientes/novo',
  CLIENTE_EDITAR: '/app/clientes/:id/editar',
  CLIENTE_DETALHES: '/app/clientes/:id',

  // Vendas
  PDV: '/app/pdv',
  EVENTOS: '/app/eventos',
  PEDIDOS: '/app/pedidos',
  CAIXA: '/app/caixa',
  VENDAS: '/app/vendas',
  VENDA_DETALHES: '/app/vendas/:id',

  // Estoque
  ESTOQUE: '/app/estoque',
  ESTOQUE_MOVIMENTACOES: '/app/estoque/movimentacoes',

  // Relatorios
  RELATORIOS: '/app/relatorios',

  // Devolucoes
  DEVOLUCOES: '/app/devolucoes',

  // Cupons
  CUPONS: '/app/cupons',

  // Credito/Fiado
  CREDITO: '/app/credito',

  // Usuarios (Admin)
  USUARIOS: '/app/usuarios',
  USUARIO_NOVO: '/app/usuarios/novo',
  USUARIO_EDITAR: '/app/usuarios/:id/editar',

  // Assinatura
  SUBSCRIPTION: '/app/assinatura',

  // Configuracoes
  CONFIGURACOES: '/app/configuracoes',
  PERFIL: '/app/perfil',
} as const;

// Funcao para gerar path com parametros
export function generatePath(path: string, params: Record<string, string>): string {
  let result = path;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
}
